"use client";
import { cn } from "@/utils/utils";
import React, { ReactNode } from "react";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

export type CollapseItemProps = {
	header?: string | React.ReactNode;
	body?: ReactNode | string;
	heightBodyClassName?: string;
	disabled?: boolean;
};

type Props = {
	items: CollapseItemProps[];
	defaultActiveKey?: number;
	defaultActiveKeys?: number[];

	classNameHead?: string;
	classNameBody?: string;
	classnameContent?: string;
	className?: string;
	hideDefaultPadding?: boolean;
	collapsible?: boolean;
	showChevron?: boolean;
	type?: "single" | "multiple";
	mode?: "up" | "down";
};

function Collapse({
	items,
	defaultActiveKey,
	defaultActiveKeys,
	classNameHead,
	classNameBody,
	classnameContent,
	className,
	hideDefaultPadding = false,
	showChevron = true,
	collapsible = true,
	type = "single",
	mode = "down",
}: Props) {
	const defaultPaddingTrigger = !hideDefaultPadding
		? "py-2 px-4 border-y-[0.5px] md:border-none border-gray-300"
		: "";
	const defaultPaddingContent = !hideDefaultPadding ? "" : "";
	const defaultPadingBody = !hideDefaultPadding ? "py-[12px]" : "";

	return (
		<>
			{type === "single" ? (
				<Accordion
					type="single"
					collapsible={collapsible}
					defaultValue={`id-${defaultActiveKey}`}
					className={className}>
					{items.map((item, index) => {
						if (item.header) {
							return (
								<AccordionItem value={`id-${index}`} key={index}>
									{mode === "down" ? (
										<>
											<AccordionTrigger
												showChevron={showChevron}
												className={cn(
													`flex items-center justify-between gap-3 cursor-pointer  bg-gray-200 md:bg-white text-base font-bold ${defaultPaddingTrigger}`,
													classNameHead
												)}>
												<p>{item.header}</p>
											</AccordionTrigger>{" "}
											<AccordionContent
												className={cn(defaultPaddingContent, classnameContent)}>
												<div className={`scrollbarCustomer `}>
													{typeof item.body === "string" ? (
														<div
															className={cn(
																`bg-white ${defaultPadingBody}`,
																classNameBody
															)}
															dangerouslySetInnerHTML={{
																__html: item.body,
															}}></div>
													) : (
														<div
															className={cn(
																`bg-white ${defaultPadingBody}`,
																classNameBody
															)}>
															{item.body}
														</div>
													)}
												</div>
											</AccordionContent>
										</>
									) : (
										<>
											<AccordionContent
												className={cn(defaultPaddingContent, classnameContent)}>
												<div className={`scrollbarCustomer `}>
													{typeof item.body === "string" ? (
														<div
															className={cn(
																`bg-white ${defaultPaddingContent}`,
																classNameBody
															)}
															dangerouslySetInnerHTML={{
																__html: item.body,
															}}></div>
													) : (
														<div
															className={cn(
																`bg-white ${defaultPaddingContent}`,
																classNameBody
															)}>
															{item.body}
														</div>
													)}
												</div>
											</AccordionContent>
											<AccordionTrigger
												showChevron={showChevron}
												className={cn(
													`flex items-center justify-between gap-3 cursor-pointer bg-gray-200 md:bg-white text-base font-bold ${defaultPaddingTrigger}`,
													classNameHead
												)}>
												<p>{item.header}</p>
											</AccordionTrigger>
										</>
									)}
								</AccordionItem>
							);
						}

						return (
							<div>
								{typeof item.body === "string" ? (
									<div dangerouslySetInnerHTML={{ __html: item.body }}></div>
								) : (
									<>{item.body}</>
								)}
							</div>
						);
					})}
				</Accordion>
			) : (
				<Accordion
					className={className}
					type="multiple"
					defaultValue={defaultActiveKeys?.map((k) => `id-${k}`) || []}
					draggable={false}>
					{items.map((item, index) => {
						return (
							<AccordionItem value={`id-${index}`} key={index}>
								{mode === "down" ? (
									<>
										<AccordionTrigger
											disabled={item.disabled}
											showChevron={showChevron}
											className={cn(
												`flex items-center justify-between gap-3 cursor-pointer bg-gray-200 md:bg-white text-base font-bold ${defaultPaddingTrigger}`,
												classNameHead
											)}>
											<p>{item.header}</p>
										</AccordionTrigger>{" "}
										<AccordionContent
											className={cn(defaultPaddingContent, classnameContent)}>
											<div className={`scrollbarCustomer `}>
												<div
													className={cn(
														`bg-white ${defaultPadingBody}`,
														classNameBody
													)}>
													{item.body}
												</div>
											</div>
										</AccordionContent>
									</>
								) : (
									<>
										<AccordionContent
											className={cn(defaultPaddingContent, classnameContent)}>
											<div className={`scrollbarCustomer `}>
												<div
													className={cn(
														`bg-white ${defaultPadingBody}`,
														classNameBody
													)}>
													{item.body}
												</div>
											</div>
										</AccordionContent>
										<AccordionTrigger
											showChevron={showChevron}
											className={cn(
												`flex items-center justify-between gap-3 cursor-pointer bg-gray-200 md:bg-white text-base font-bold ${defaultPaddingTrigger}`,
												classNameHead
											)}>
											<p>{item.header}</p>
										</AccordionTrigger>
									</>
								)}
							</AccordionItem>
						);
					})}
				</Accordion>
			)}
		</>
	);
}

export default Collapse;
